import React, { FC } from "react";
import { BoxWrapper, DashboardTitle, DashboardWrapper } from "../../../styles";
import TableSection from "../../../../../components/table/TableSection";
import { FiBiSessionsTableData } from "../../../Fibi AI/table-data";
import { useGetBusinessClientAllSession } from "../../../../../../../hooks/ai/useAI";
import { GetSingleBusinessUsersRes } from "../../../../../../../api/business/users/types";

interface Props {
  infoData: GetSingleBusinessUsersRes;
}

const FibiClientsSessions: FC<Props> = ({ infoData }) => {
  const { data, isError, isLoading } = useGetBusinessClientAllSession(
    infoData.userData.userInfo.buid || ""
  );

  return (
    <DashboardWrapper>
      <DashboardTitle>My FiBi Sessions</DashboardTitle>
      <BoxWrapper>
        <TableSection
          dataItems={data}
          tableData={FiBiSessionsTableData(
            true,
            infoData.userData.userInfo.buid
          )}
          isError={isError}
          isLoading={isLoading}
        />
      </BoxWrapper>
    </DashboardWrapper>
  );
};

export default FibiClientsSessions;
